/**
 * /**
 *  * Generated Zod schemas by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  z as zod
} from 'zod';


/**
 * Retrieve learning content (intro, academy, faq). Visible to all authenticated users.
 * @summary Get learning content
 */
export const learningsRetrieveResponseStatusDefault = "success";

export const learningsRetrieveResponse = zod.object({
  "data": zod.object({
  "intro": zod.string().nullish(),
  "academy": zod.string().nullish(),
  "faq": zod.any().optional()
}),
  "status": zod.string().default(learningsRetrieveResponseStatusDefault),
  "message": zod.string().nullish()
})

/**
 * Update learning content (intro, academy, faq). Admin only.
 * @summary Update learning content
 */
export const learningsPartialUpdateBody = zod.object({
  "intro": zod.string().nullish(),
  "academy": zod.string().nullish(),
  "faq": zod.any().optional()
})

export const learningsPartialUpdateResponseStatusDefault = "success";

export const learningsPartialUpdateResponse = zod.object({
  "data": zod.object({
  "intro": zod.string().nullish(),
  "academy": zod.string().nullish(),
  "faq": zod.any().optional()
}),
  "status": zod.string().default(learningsPartialUpdateResponseStatusDefault),
  "message": zod.string().nullish()
})

